export const USER_CHOICE_LANGUAGE = "user-choice-language";

export const API_URL = process.env.REACT_APP_API_URL || "https://devices.api.dev.aufzughelden.com";
export const auth0_domain = process.env.REACT_APP_AUTH0_DOMAIN || "login.test.digitalspine.io";
export const auth0_clientId = process.env.REACT_APP_AUTH0_CLIENTID || "uAblOAxBm0zNJk83xgApalsWm5qkM6o4";
export const auth0_audience = process.env.REACT_APP_AUTH0_AUDIENCE || "https://devices.api.dev.aufzughelden.com";
export const admin_org_id = process.env.REACT_APP_ADMIN_ORG_ID || "org_5jug41cYcyk6dVrn";
